import React, { useState } from "react";
import { Link as RouterLink } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import PropTypes from "prop-types";
import clsx from "clsx";
import * as Yup from "yup";
import { Formik } from "formik";
import { useSnackbar } from "notistack";

import {
  Box,
  Button,
  FormHelperText,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { createNews } from "src/actions/mgmtNewsAction";


const useStyles = makeStyles(() => ({
  root: {},
  editor: {
    "& .ql-editor": {
      height: 400,
    },
  },
}));

function NewsForm({ customerId, onClick, customerIdList, userType, className, ...rest }) {
  const classes = useStyles();

  const [image, setImage] = useState('');
  const account = useSelector((state) => state.account);

  const addedBy = account.user.email;
  function handleImage(e) {
    console.log(e.target.files)
    setImage(e.target.files[0])
  }

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  return (

    <Formik
      initialValues={{
        customerId: customerId,
        heading: "",
        description: "",
        imageUrl: "",
        videoUrl: "",
      }}
      validationSchema={Yup.object().shape({
        heading: Yup.string().max(50).required("Heading  is required"),
      })}
      onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
        try {
          await dispatch(createNews(addedBy, values, image));
          setStatus({ success: true });
          setSubmitting(false);
          enqueueSnackbar("News Created Successfully", {
            variant: "success",
          });          
          navigate("/app/management/news/view");

        } catch (err) {
          setErrors({ submit: err.message });
          setStatus({ success: false });
          setSubmitting(false);
          enqueueSnackbar("Failed to Add News", {
            variant: "failure",
          });
        }
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        isSubmitting,
        setFieldValue,
        touched,
        values,
      }) => (
        <form
          onSubmit={handleSubmit}
          className={clsx(classes.root, className)}
          {...rest}
        >
          <Grid container spacing={3} padding={2}>
            {/* <Grid item xs={12}>
                  <TextField
                    error={Boolean(
                      touched.customerId && errors.customerId
                    )}
                    fullWidth
                    helperText={
                      touched.customerId && errors.customerId
                    }
                    label="Customer Id"
                    name="customerId"
                    onBlur={handleBlur}
                    // onChange={handleChange}
                    value={values.customerId}
                    variant="outlined"
                  />
                </Grid> */}

            <Grid item xs={12}>
              <TextField
                error={Boolean(
                  touched.heading && errors.heading
                )}
                fullWidth
                helperText={
                  touched.heading && errors.heading
                }
                label="Heading"
                name="heading"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.heading}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                error={Boolean(
                  touched.description && errors.description
                )}
                fullWidth
                helperText={
                  touched.description && errors.description
                }
                multiline
                rows={4}
                label="Description"
                name="description"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.description}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12}>
              <Typography>Upload News Image</Typography>
              <TextField
                error={Boolean(
                  touched.imageUrl && errors.imageUrl
                )}
                fullWidth
                helperText={
                  touched.imageUrl && errors.imageUrl
                }
                type="file"

                name="imageUrl"
                onBlur={handleBlur}
                onChange={handleImage}
                value={values.image}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                error={Boolean(
                  touched.videoUrl && errors.videoUrl
                )}
                fullWidth
                helperText={
                  touched.videoUrl && errors.videoUrl
                }
                label="Video Url"
                name="videoUrl"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.videoUrl}
                variant="outlined"
              />
            </Grid>
          </Grid>

          {errors.submit && (
            <Box mt={3}>
              <FormHelperText error>{errors.submit}</FormHelperText>
            </Box>
          )}
          <Box mt={2} padding={2}>
            <Button
              color="secondary"
              variant="contained"
              type="submit"
              disabled={isSubmitting}
              style={{ marginBottom: '5em' }}
            >
              Submit
            </Button>
            <Button style={{ marginLeft: '1em', marginBottom: '5em' }} 
                color="secondary" variant='contained' 
                component={RouterLink}
                to="/app/management/news/view"
                >
                Cancel
              </Button>
          </Box>
        </form>
      )}
    </Formik>
  );
}

NewsForm.propTypes = {
  className: PropTypes.string,
  cid: PropTypes.number,
  onClick: PropTypes.func,
};

export default NewsForm;